import { render, staticRenderFns } from "./successStoriesPage.vue?vue&type=template&id=24f764d6&"
import script from "./successStoriesPage.vue?vue&type=script&lang=js&"
export * from "./successStoriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports